import API from "./API";


export const getService = async (url)=>{
    const response = await API.get(url);
    return response;
}


export const postService = async (url,data = undefined ,headers= undefined)=>{
const response = await API.post(url,data,{headers})
// console.log("🚀 ~ file: APIService.js:12 ~ postService ~ response:", response);
return response;
}


export const removeService = async (url, data = undefined, headers = undefined) => {
    const response = await API.delete(url, { data, headers });
    return response;
};

export const putService = async (url, data = undefined, headers = undefined) => {
    const response = await API.put(url, data, { headers });
    return response;
};
